/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class UserUpdateControllerService {
    /**
     * @param userId
     * @param formData User personal information and signature to update
     * @returns any User personal information and image updated successfully
     * @throws ApiError
     */
    public static userUpdateControllerUpdateUser(
        userId?: string,
        formData?: {
            name?: string;
            photo?: Blob;
            signature?: Blob;
        },
    ): CancelablePromise<{
        message?: string;
        user?: Record<string, any>;
    }> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/update-user',
            query: {
                'userId': userId,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
}
